import React from 'react';
import PropTypes from 'prop-types';

import Result from './Result';
import styles from './Results.scss';

function Results({ searchResults, onResultClick }) {
  return (
    <div className={styles.results}>
      <div>
        {searchResults.map((result, i) => {
          let parent = result.athena_name;
          let parentType = 'Node';
          let id = result.node_id;

          if (result.type === Result.TYPES.STORY) {
            parent = result.domain_name;
            id = result.node_id;
            parentType = 'Bot';
          }

          if (result.type === Result.TYPES.SUBSTORY) {
            parent = result.story_name;
            id = result.node_id;
            parentType = 'Story';
          }

          if (result.type === Result.TYPES.NODE && result.sub_story_name) {
            parent = result.sub_story_name;
            parentType = 'Substory';
          } else if (result.type === Result.TYPES.NODE && result.story_name) {
            parent = result.story_name;
            parentType = 'Story';
          } else if (result.type === Result.TYPES.NODE && result.domain_name) {
            parent = result.domain_name;
            parentType = 'Bot';
          }

          if (result.type === Result.TYPES.GENERIC_RESPONSE) {
            parent = result.domain_name;
            parentType = 'Bot';
          }

          return (
            <Result
              key={i}
              id={id}
              type={result.type}
              value={result.string}
              highlight={result.matches}
              pattern={result.pattern}
              onClick={onResultClick}
              parent={parent}
              parentType={parentType}
            />
          );
        })}
      </div>
    </div>
  );
}

Results.propTypes = {
  onResultClick: PropTypes.func,
  searchResults: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      match_string: PropTypes.string,
      match_indexes: PropTypes.string,
      match_pattern: PropTypes.string,
      node_name: PropTypes.string,
    })
  ),
};

Results.defaultProps = {
  searchResults: [],
  onResultClick: () => {},
};

export default Results;
